import { HeaderModule } from '@app/components/header/header.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CarouselModule } from '@app/components/carousel/carousel.module';
import { ContainerScrollModule } from '@app/components/container-scroll/container-scroll.module';
import { IconsModule } from '@app/components/icons/icons.module';
import { ListItemsModule } from '@app/components/list-items/list-items.module';
import { SendRateAndCommentModule } from '@app/components/send-rate-and-comment/send-rate-and-comment.module';
import { TabScrollSpyModule } from '@app/components/tab-scroll-spy/tab-scroll-spy.module';
import { SharedModule } from '@app/shared/shared.module';

import { AgentsSliderComponent } from './agents-slider/agents-slider.component';
import { ListItemAudioBookComponent } from './list-item-audio-book/list-item-audio-book.component';
import { CommentTemplateComponent } from './pdp-comment/CommentTemplate/comment-template/comment-template.component';
import { PdpCommentComponent } from './pdp-comment/pdp-comment.component';
import { PdpDialogMarketsComponent } from './pdp-dialog-markets/pdp-dialog-markets.component';
import { PDPRoutingModule } from './pdp-routing.module';
import { PdpComponent } from './pdp/pdp.component';
import { PdpButtonComponent } from './pdp/pdp-button/pdp-button.component';
import { DialogDownloadPDPComponent } from './dialog-download-pdp/dialog-download-pdp.component';


@NgModule({
  declarations: [
    PdpComponent,
    PdpCommentComponent,
    CommentTemplateComponent,
    AgentsSliderComponent,
    PdpDialogMarketsComponent,
    ListItemAudioBookComponent,
    PdpButtonComponent,
    DialogDownloadPDPComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedModule,
    CarouselModule,
    TabScrollSpyModule,
    PDPRoutingModule,
    ListItemsModule,
    ContainerScrollModule,
    SendRateAndCommentModule,
    IconsModule,
    HeaderModule
  ],
  entryComponents:[
    PdpDialogMarketsComponent
  ]
})
export class PDPModule { }
